import { type z } from 'zod';

import {
  type HTTP_BARCODE_RESPONSE_SCHEMA,
  type ORDER_SHIPMENT_BARCODE_CONTENT_SCHEMA,
} from '../schemata/barcode.schema';

export enum BarcodeType {
  OrderShipment = 'ORDER_SHIPMENT',
}

export type OrderShipmentBarcodeContent = z.TypeOf<typeof ORDER_SHIPMENT_BARCODE_CONTENT_SCHEMA>;
export type HttpBarcodeResponse = z.TypeOf<typeof HTTP_BARCODE_RESPONSE_SCHEMA>;
